import Vue from 'vue'
import App from './App.vue'
import store from './store/store.js'
import mixins from './mixins.js'
import './registerServiceWorker'
import './plugins/sentry.js'
import './plugins/fontawesome.js'
import './plugins/vue-analytics.js'
import './plugins/vue2-hammer.js'
import './plugins/platform.js'
import './plugins/vue-scrollto.js'
import './plugins/vuelidate'
import './plugins/vue-axios.js'

import { onAnalyticsReady } from 'vue-analytics'

Vue.mixin(mixins)

Vue.config.productionTip = false

const Instance = new Vue({
  store,
  render: h => h(App),
  mounted() {
    if (this.$platform.os.family == 'Android' || this.$platform.os.family == 'iOS') {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        // app is already installed
      } else {
        this.$store.state.addToHomescreen.show = true
      }
    } else {
      this.$store.state.isMobile = false
    }

    if (this.$platform.name == 'IE') {
      let ie11 = this.$platform.version.substring(0,2) == "11"
      if (!ie11) {
        this.$store.state.browserSupported = false
      }
    }

    this.$store.dispatch('resumeState')
    this.$store.dispatch('auth/extendSession')

  }
})

let mounted = false

onAnalyticsReady().then(() => {
  Instance.$mount('#wcc-app')
  mounted = true
}).catch(() => {
  Instance.$mount('#wcc-app')
  mounted = true
})

// Otherwise it can't deal with adblockers
// May miss some analytics hits
setTimeout(() => {
  if (!mounted) {
    Instance.$mount('#wcc-app')
    mounted = true
  }
}, 500);

function updateConnectionStatus() {
  // In case Vuex isn't up yet.
  if (Instance.$store) {
    Instance.$store.state.online = navigator.onLine
  }
}

window.addEventListener('online', updateConnectionStatus)
window.addEventListener('offline', updateConnectionStatus)